@if (!inputService.hidden && inputService.formInputDefinition && inputService.control) {
  <ng-container [formGroup]="inputService.formGroup">
    <mat-form-field>
      <mat-label>{{inputService.computedTitle | translate}}</mat-label>
      <input autocomplete="off" type='password' matInput [placeholder]="(inputService.inputConfig.placeholder || '') | translate" [formControlName]='inputService.formControlKey'>
      @if (inputService.inputConfig.hint) {
        <mat-hint>{{inputService.inputConfig.hint | translate}}</mat-hint>
      }
      @if (!inputService.control.valid) {
        <mat-error>{{inputService.errorMessage | translate}}</mat-error>
      }
    </mat-form-field>
  </ng-container>
}